import React from "react";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import FilterListIcon from "@mui/icons-material/FilterList";
import CustomSelect from "../CustomSelect/CustomSelect";

interface SortControlsProps {
  sortKey?: string;
  isAscending: boolean;
  onSortKeyChange?: (key: string) => void;
  onDirectionChange: (isAscending: boolean) => void;
  options?: { value: string; label: string }[];
  selectWidth?: number;
  showSelect?: boolean;
  /** Video-section bar spec (40px / 10px radius / 13px label, quiet arrows).
   *  Opt-in: every other consumer renders exactly as before. */
  dense?: boolean;
}

const SortControls: React.FC<SortControlsProps> = ({
  sortKey,
  isAscending,
  onSortKeyChange,
  onDirectionChange,
  options,
  selectWidth = 155,
  showSelect = false,
  dense = false,
}) => {
  return (
    <div className={`flex items-center ${dense ? "gap-2.5" : "gap-4"}`}>
      {showSelect && options && onSortKeyChange && (
        <CustomSelect
          labelId="sorting-key"
          name="sortingKey"
          value={sortKey || ""}
          onChange={onSortKeyChange}
          options={options}
          width={selectWidth}
          placeholder="Sort by"
          showPlaceholderIcon
          placeholderIcon={<FilterListIcon sx={dense ? { fontSize: 20 } : undefined} />}
          sx={
            dense
              ? {
                  height: 40,
                  borderRadius: "10px",
                  "& .MuiTypography-root": { fontSize: 13 },
                }
              : undefined
          }
        />
      )}
      <div
        className={`flex h-10 items-center border border-border-token overflow-hidden ${
          dense ? "dark:border-muted rounded-[10px]" : "rounded-lg"
        }`}
      >
        <span
          className={`rounded flex items-center justify-center w-10 h-full cursor-pointer transition-colors duration-200 ${
            isAscending ? "bg-tint" : ""
          }`}
          onClick={() => onDirectionChange(true)}
        >
          <KeyboardArrowUpIcon
            className={`${dense ? "!h-6 !w-6" : "!h-9 !w-9"} transition-colors duration-200 ${
              isAscending ? "text-accent" : "text-muted"
            }`}
          />
        </span>
        <span
          className={`rounded flex items-center justify-center w-10 h-full cursor-pointer transition-colors duration-200 ${
            !isAscending ? "bg-tint" : ""
          }`}
          onClick={() => onDirectionChange(false)}
        >
          <KeyboardArrowDownIcon
            className={`${dense ? "!h-6 !w-6" : "!h-9 !w-9"} transition-colors duration-200 ${
              !isAscending ? "text-accent" : "text-muted"
            }`}
          />
        </span>
      </div>
    </div>
  );
};

export default SortControls;
